import { DeviceService } from '../../services/deviceService';
import { DeviceActionTypes, DeviceState } from './types';

export function deviceReducer(
  state: DeviceState | undefined,
  action: DeviceActionTypes,
): DeviceState {
  if (state === undefined) {
    const deviceId = DeviceService.getDeviceId();
    return {
      deviceId: deviceId,
    };
  }

  return state;
}
